import { gql } from "apollo-boost";

export const CREATE_PRINTER = gql`
mutation CreatePrinter($data: PrinterInput) {
    createPrinter(data: $data) {
      id
    }
  }
`

export const DELETE_PRINTER = gql`
mutation DeletePrinter($where: PrinterWhereInputOne!) {
    deletePrinter(where: $where) {
      id
    }
  }
`

export const UPDATE_PRINTER = gql`
mutation UpdatePrinter($where: PrinterWhereInputOne!, $data: PrinterInput) {
    updatePrinter(where: $where, data: $data) {
      id
    }
  }
`

export const CHOOSE_PRINTER = gql`
mutation ChoosePrinter($data: PrinterInput, $where: PrinterWhereInputOne!) {
  choosePrinter(data: $data, where: $where) {
    id
  }
}
`